module.exports = __webpack_public_path__ + "static/media/Swanson-bldg1.b7cd7999.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/undergrad/Swanson-bldg1.jpg
// module id = 480
// module chunks = 0